import { render, staticRenderFns } from "./MarkDetailPage.vue?vue&type=template&id=10c356f4&scoped=true&"
import script from "./MarkDetailPage.vue?vue&type=script&lang=js&"
export * from "./MarkDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./MarkDetailPage.vue?vue&type=style&index=0&id=10c356f4&scoped=true&lang=css&"
import style1 from "./MarkDetailPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c356f4",
  null
  
)

export default component.exports